import React from 'react';
import { AlertTriangle, XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-stone-100" data-id="element-113">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-114">
        <div className="text-center mb-12" data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-116">
            ¿Alguna vez has sentido ese pinchazo agudo al intentar levantarte de
            la cama?
          </h2>
          <p className="text-xl text-slate-700 leading-relaxed" data-id="element-117">
            ¿O ese miedo silencioso cuando ves una escalera y te preguntas si
            tus piernas aguantarán?
          </p>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-stone-200 mb-12" data-id="element-118">
          <p className="text-lg md:text-xl text-slate-800 mb-6" data-id="element-119">
            No estás sola. Muchas de nuestras mujeres latinas en este país han
            trabajado duro toda su vida, cuidando a otros, trabajando de pie,
            descuidando sus propias articulaciones.
          </p>
          <p className="text-lg md:text-xl text-slate-800 font-medium" data-id="element-120">
            Y ahora, cuando es momento de disfrutar a los nietos y los frutos de
            su esfuerzo, el dolor de rodilla parece decir:{' '}
            <span className="text-red-600 font-bold" data-id="element-121">"Detente"</span>.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-122">
          <div className="bg-red-50 p-6 rounded-xl border border-red-100" data-id="element-123">
            <div className="flex items-center gap-3 mb-4" data-id="element-124">
              <XCircle className="h-8 w-8 text-red-500" data-id="element-125" />
              <h3 className="text-xl font-bold text-red-900" data-id="element-126">
                El Problema Real
              </h3>
            </div>
            <p className="text-slate-700" data-id="element-127">
              La medicina en este país es cara. Una sesión de fisioterapia puede
              costar lo que usas para el mercado de la semana. Y los doctores a
              veces solo te dan pastillas que adormecen el dolor, pero no
              arreglan el problema.
            </p>
          </div>

          <div className="bg-amber-50 p-6 rounded-xl border border-amber-100" data-id="element-128">
            <div className="flex items-center gap-3 mb-4" data-id="element-129">
              <AlertTriangle className="h-8 w-8 text-amber-600" data-id="element-130" />
              <h3 className="text-xl font-bold text-amber-900" data-id="element-131">
                La Mentira Común
              </h3>
            </div>
            <p className="text-slate-700" data-id="element-132">
              Te dicen que "es la edad".{' '}
              <span className="font-bold" data-id="element-133">¡Mentira!</span> No es solo la edad.
              Es falta de lubricación y fuerza. Tus rodillas no están "viejas",
              están oxidadas y necesitan movimiento correcto.
            </p>
          </div>
        </div>
      </div>
    </section>;
}